import { Component } from '@angular/core';
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatCard, MatCardContent} from "@angular/material/card";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ApiService} from "../api.service";
import {Router, RouterLink} from "@angular/router";

@Component({
  selector: 'app-admin-login',
  imports: [
    MatButton,
    MatCard,
    MatCardContent,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatIconButton,
    RouterLink
  ],
  templateUrl: './admin-login.component.html',
  styleUrl: './admin-login.component.css'
})
export class AdminLoginComponent {
  public username: any;
  public password: any;
  public disableInputs: boolean = false;
  public loading: boolean = false;
  public errorMsg: string = '';

  admLoginForm = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    submit: new FormControl()
  });

  constructor(public api: ApiService, public router: Router) {
  }

  async login() {
    this.username = this.admLoginForm.get('username')?.value;
    this.password = this.admLoginForm.get('password')?.value;
    this.admLoginForm.get('username')?.disable();
    this.admLoginForm.get('password')?.disable();
    this.admLoginForm.get('submit')?.disable();
    this.disableInputs = true;
    this.loading = true;
    const error = await this.api.adminLogin(this.username, this.password);
    this.loading = false;
    if (error) {
      this.errorMsg = error;
      setTimeout(() => {
        this.admLoginForm.get('username')?.enable();
        this.admLoginForm.get('password')?.enable();
        this.admLoginForm.get('submit')?.enable();
        this.disableInputs = false;
      }, 1000);
    }
    else {
      this.errorMsg = '';
      this.router.navigate(['admin/users']);
    }
  }

  ngAfterViewInit() {
    if (!this.api.isLogged)
      (document.querySelector('body') as HTMLElement).style.backgroundImage = 'linear-gradient(35deg, #fe3620 0%, #ff7c00 30%, #ff7c00 70%, #fe3620 90%)';
  }
  ngOnDestroy() {
    (document.querySelector('body') as HTMLElement).style.backgroundImage = 'unset';
  }

}
